// extracted by mini-css-extract-plugin
export default {"backTotop":"backtotop_backTotop__xIpB2"};